import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const unitsModuleDefaultVariants = {}
const unitsModuleCompoundVariants = []

const unitsModuleSlotNames = [
  [
    "contentStack",
    "units-module__contentStack"
  ],
  [
    "floorPlanImageOuter",
    "units-module__floorPlanImageOuter"
  ],
  [
    "floorPlanImageWrapper",
    "units-module__floorPlanImageWrapper"
  ],
  [
    "floorPlanImage",
    "units-module__floorPlanImage"
  ],
  [
    "floorPlanImageButton",
    "units-module__floorPlanImageButton"
  ],
  [
    "noFloorPlanPlaceholder",
    "units-module__noFloorPlanPlaceholder"
  ],
  [
    "placeholderText",
    "units-module__placeholderText"
  ],
  [
    "placeholderSubtext",
    "units-module__placeholderSubtext"
  ],
  [
    "floorPlanSummary",
    "units-module__floorPlanSummary"
  ],
  [
    "floorPlanSummaryRow",
    "units-module__floorPlanSummaryRow"
  ],
  [
    "floorPlanSummarySeparator",
    "units-module__floorPlanSummarySeparator"
  ],
  [
    "floorPlanFeesBadge",
    "units-module__floorPlanFeesBadge"
  ],
  [
    "totalMonthlyPriceNotice",
    "units-module__totalMonthlyPriceNotice"
  ],
  [
    "cardContent",
    "units-module__cardContent"
  ],
  [
    "unitTableResponsive",
    "units-module__unitTableResponsive"
  ],
  [
    "unitTable",
    "units-module__unitTable"
  ],
  [
    "unitNameColumn",
    "units-module__unitNameColumn"
  ],
  [
    "unitRentColumn",
    "units-module__unitRentColumn"
  ],
  [
    "unitDetailsColumn",
    "units-module__unitDetailsColumn"
  ],
  [
    "unitTableHeader",
    "units-module__unitTableHeader"
  ],
  [
    "unitTableHeaderAvailable",
    "units-module__unitTableHeaderAvailable"
  ],
  [
    "unitTableHeaderChevron",
    "units-module__unitTableHeaderChevron"
  ],
  [
    "unitTableRow",
    "units-module__unitTableRow"
  ],
  [
    "cellWithBadgeArea",
    "units-module__cellWithBadgeArea"
  ],
  [
    "badgeArea",
    "units-module__badgeArea"
  ],
  [
    "unitNameCell",
    "units-module__unitNameCell"
  ],
  [
    "unitNameButton",
    "units-module__unitNameButton"
  ],
  [
    "unitNameText",
    "units-module__unitNameText"
  ],
  [
    "rentCellContent",
    "units-module__rentCellContent"
  ],
  [
    "rentValue",
    "units-module__rentValue"
  ],
  [
    "rentText",
    "units-module__rentText"
  ],
  [
    "priceDropOriginal",
    "units-module__priceDropOriginal"
  ],
  [
    "priceDropArrow",
    "units-module__priceDropArrow"
  ],
  [
    "placeholderValue",
    "units-module__placeholderValue"
  ],
  [
    "availableCell",
    "units-module__availableCell"
  ],
  [
    "chevronCell",
    "units-module__chevronCell"
  ],
  [
    "chevronChar",
    "units-module__chevronChar"
  ],
  [
    "seeAllLink",
    "units-module__seeAllLink"
  ],
  [
    "seeAllArrow",
    "units-module__seeAllArrow"
  ],
  [
    "mobileCarouselItem",
    "units-module__mobileCarouselItem"
  ],
  [
    "desktopCarouselItem",
    "units-module__desktopCarouselItem"
  ],
  [
    "desktopCarouselItemWithoutImage",
    "units-module__desktopCarouselItemWithoutImage"
  ],
  [
    "carouselContainer",
    "units-module__carouselContainer"
  ],
  [
    "desktopCarouselContainer",
    "units-module__desktopCarouselContainer"
  ],
  [
    "desktopCarouselRow",
    "units-module__desktopCarouselRow"
  ],
  [
    "desktopArrowColumn",
    "units-module__desktopArrowColumn"
  ],
  [
    "desktopCardsArea",
    "units-module__desktopCardsArea"
  ],
  [
    "desktopControlButton",
    "units-module__desktopControlButton"
  ],
  [
    "baseCard",
    "units-module__baseCard"
  ],
  [
    "compactCard",
    "units-module__compactCard"
  ],
  [
    "compactCardWithoutImage",
    "units-module__compactCardWithoutImage"
  ],
  [
    "compactImageWrapper",
    "units-module__compactImageWrapper"
  ],
  [
    "compactUnitTableWrapper",
    "units-module__compactUnitTableWrapper"
  ],
  [
    "bedroomTab",
    "units-module__bedroomTab"
  ],
  [
    "dotContainer",
    "units-module__dotContainer"
  ],
  [
    "floorPlanDots",
    "units-module__floorPlanDots"
  ],
  [
    "floorPlanDot",
    "units-module__floorPlanDot"
  ],
  [
    "modalBackdrop",
    "units-module__modalBackdrop"
  ],
  [
    "modalContent",
    "units-module__modalContent"
  ],
  [
    "modalHeader",
    "units-module__modalHeader"
  ],
  [
    "modalTitle",
    "units-module__modalTitle"
  ],
  [
    "modalTitleDetail",
    "units-module__modalTitleDetail"
  ],
  [
    "modalCloseButton",
    "units-module__modalCloseButton"
  ],
  [
    "modalBody",
    "units-module__modalBody"
  ],
  [
    "modalImageColumn",
    "units-module__modalImageColumn"
  ],
  [
    "modalTableColumn",
    "units-module__modalTableColumn"
  ],
  [
    "sortContainer",
    "units-module__sortContainer"
  ],
  [
    "sortTrigger",
    "units-module__sortTrigger"
  ],
  [
    "sortLabel",
    "units-module__sortLabel"
  ],
  [
    "sortValue",
    "units-module__sortValue"
  ],
  [
    "sortChevron",
    "units-module__sortChevron"
  ],
  [
    "sortDropdownPanel",
    "units-module__sortDropdownPanel"
  ],
  [
    "sortOption",
    "units-module__sortOption"
  ],
  [
    "sortOptionSelected",
    "units-module__sortOptionSelected"
  ],
  [
    "sheetImageBorder",
    "units-module__sheetImageBorder"
  ],
  [
    "sheetImagePadding",
    "units-module__sheetImagePadding"
  ],
  [
    "sheetPlaceholderInner",
    "units-module__sheetPlaceholderInner"
  ],
  [
    "sheetPlaceholderText",
    "units-module__sheetPlaceholderText"
  ],
  [
    "sheetPlaceholderSubtext",
    "units-module__sheetPlaceholderSubtext"
  ],
  [
    "seeAllUnitsImage",
    "units-module__seeAllUnitsImage"
  ],
  [
    "headerTitleDetail",
    "units-module__headerTitleDetail"
  ]
]
const unitsModuleSlotFns = /* @__PURE__ */ unitsModuleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, unitsModuleDefaultVariants, getSlotCompoundVariant(unitsModuleCompoundVariants, slotName))])

const unitsModuleFn = memo((props = {}) => {
  return Object.fromEntries(unitsModuleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const unitsModuleVariantKeys = []
const getVariantProps = (variants) => ({ ...unitsModuleDefaultVariants, ...compact(variants) })

export const unitsModule = /* @__PURE__ */ Object.assign(unitsModuleFn, {
  __recipe__: false,
  __name__: 'unitsModule',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: unitsModuleVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, unitsModuleVariantKeys)
  },
  getVariantProps
})